import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { ListComponent } from '@app/common/templates/list/list.component';
import { Module } from '@app/models/permission';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import { ExportService } from '@app/services/export.service';
import { SettingsService } from '@app/services/settings.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { TblKomponenteDetailComponent } from '../detail/detail.component';

@Component({
	templateUrl: '../../../../common/templates/list/list.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/list/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblKomponenteListComponent extends ListComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public changeDetectorRef: ChangeDetectorRef,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public elRef: ElementRef,
		public exportService: ExportService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public settingsService: SettingsService,
		public translate: TranslateService,
		public dialogService: DialogService,
	) {
		super(accountService, breadcrumbService, changeDetectorRef, confirmationService, crudService, elRef, exportService, globals, messageService, router, settingsService, translate, dialogService);

		this.apiUrl = 'TblKomponente';
		this.name = 'MENU.KOMPONENTE';
		this.url = '/' + PATH.KOMPONENTE;
		this.module = Module.Masterdata;

		this.possibleCols = [
			{ type: 'numeric', key: 'lfd_nummer', required: true, width: 100 },
			{ type: 'text', key: 'ankey', required: true, width: 250 },
			{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
			{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 250 },
			{ type: 'text', key: 'FREMD_komponente_typ_ankey', required: false, width: 250 },
			{ type: 'text', key: 'FREMD_komponente_typ_bezeichnung', required: false, width: 400 },
			{ type: 'text', key: 'FREMD_komponente_typ_bezeichnung_kurz', required: false, width: 250 },
			{ type: 'text', key: 'FREMD_komponente_typ_gruppe_bezeichnung', required: false, width: 300 },
			{ type: 'text', key: 'serial_no', required: false, width: 400 },
			{ type: 'text', key: 'lizenzkey_qt5', required: false, width: 600 },
			{ type: 'text', key: 'lizenzkey_lic_ki_lib', required: false, width: 600 },
			{ type: 'text', key: 'lizenzkey_visy_software', required: false, width: 600 },
			{ type: 'text', key: 'lizenzkey_sywatec_software', required: false, width: 600 },
			{ type: 'text', key: 'bemerkungen', required: false, width: 600 },
			{ type: 'numeric', key: 'feature_flags', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_fahrzeug_ankey', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_fahrzeug_bezeichnung', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_lexware_projekt_nummer', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_fahrzeug_kennzeichen', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_fahrzeug_fahrgestellnummer', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_fahrzeug_logbox_serial', required: false, width: 300 },
			{ type: 'numeric', key: 'FREMD_komponente_fahrzeug_zugeordnet_von_string', required: false, width: 300 },
			{ type: 'numeric', key: 'FREMD_komponente_fahrzeug_zugeordnet_bis_string', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_komponente_fahrzeug_zuordnung_bemerkungen', required: false, width: 300 },
		];
		this.cols = [
			{ type: 'numeric', key: 'lfd_nummer', required: true, width: 100 },
			{ type: 'text', key: 'ankey', required: true, width: 250 },
			{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
			{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 250 },
			{ type: 'text', key: 'FREMD_komponente_typ_bezeichnung', required: false, width: 400 },
			{ type: 'text', key: 'FREMD_komponente_typ_bezeichnung_kurz', required: false, width: 250 },
			{ type: 'text', key: 'FREMD_komponente_typ_gruppe_bezeichnung', required: false, width: 300 },
			{ type: 'text', key: 'serial_no', required: false, width: 400 },
			{ type: 'text', key: 'lizenzkey_qt5', required: false, width: 600 },
			{ type: 'text', key: 'lizenzkey_lic_ki_lib', required: false, width: 600 },
			{ type: 'text', key: 'lizenzkey_visy_software', required: false, width: 600 },
			{ type: 'text', key: 'lizenzkey_sywatec_software', required: false, width: 600 },
			{ type: 'text', key: 'bemerkungen', required: false, width: 600 },
			{ type: 'text', key: 'FREMD_lexware_projekt_nummer', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_fahrzeug_kennzeichen', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_fahrzeug_fahrgestellnummer', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_fahrzeug_logbox_serial', required: false, width: 300 },
			{ type: 'numeric', key: 'FREMD_komponente_fahrzeug_zugeordnet_von_string', required: false, width: 300 },
			{ type: 'numeric', key: 'FREMD_komponente_fahrzeug_zugeordnet_bis_string', required: false, width: 300 },
			{ type: 'text', key: 'FREMD_komponente_fahrzeug_zuordnung_bemerkungen', required: false, width: 300 },
		];

		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.LIST', routerLink: [this.url + '/' + PATH.LIST] }
		]);
	}
}
